import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { smallStore } from 'stores/smallStore/smallStore'
import { WindMachineViewDetailsMenu } from '../../_utils/by-domain/windMachine/WindMachineViewDetailsMenu/WindMachineViewDetailsMenu'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'

const publishFrostFanPermission = 'PUBLISH_FROST_FAN_OPERATIONAL_DEVICE_SETTINGS'

export const WindMachineSettingsTitleLink = () => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (
    !selectedPropertyHasPermission({
      permission: publishFrostFanPermission,
    })
  ) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        key="wind-machine-control-menu-item"
        data-role="menu-item"
        onClick={() =>
          smallStore.setState((s) => ({
            ...s,
            showWindMachineViewDetails: true,
          }))
        }
      >
        {translate.phrases.placeholder('Controls')}
      </ResponsiveMenuItem>
      <WindMachineViewDetailsMenu key="wind-machine-control-modal" data-role="modal" />
    </>,
  )

  return titleLink
}
